import { CSSProperties } from '../../../../models/styles.interfaces';
import {
  IconLabel,
  VisibilityConfig
} from '../models/label-with-icon.interfaces';

export const labelIconMockContent: IconLabel = {
  size: 'normal',
  role: 'title',
  iconPath: '',
  title: ''
};

export const labelIconMockStyles: CSSProperties = {
  lineHeight: 'normal',
  verticalAlign: 'start'
};

export const labelIconMockConfig: VisibilityConfig = {
  visible: false
};
